import { render, staticRenderFns } from "./PlatformSelector.vue?vue&type=template&id=b4deab4a&scoped=true"
import script from "./PlatformSelector.vue?vue&type=script&lang=js"
export * from "./PlatformSelector.vue?vue&type=script&lang=js"
import style0 from "./PlatformSelector.vue?vue&type=style&index=0&id=b4deab4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4deab4a",
  null
  
)

export default component.exports